import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid2,
  IconButton,
  InputBase,
  Paper,
  Stack,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
// import SearchIcon from "@mui/icons-material/Search";
import {
  FaCircleChevronDown,
  FaIndianRupeeSign,
  FaPlus,
  FaRupeeSign,
} from "react-icons/fa6";
import { styled, useTheme } from "@mui/material/styles";
import TableComponent from "components/grid";
import AddNcr from "./AddNcr";
import { useDispatch } from "store";
import { closeSnackbar, openSnackbar } from "store/slices/snackbar";
import { useGetAllIssueQuery } from "store/slices/apis/packageSlice";
import PaginationComponent from "components/ui-components/PaginationComponent";
import { HighlightOffTwoTone } from "@mui/icons-material";
import { IoMdClose, IoMdSearch } from "react-icons/io";
import { useNavigate, useParams } from "react-router-dom";
import EditNcr from "./EditNcr";
import moment from "moment";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  useDeleteKeyNcrMutation,
  useGetSubmittedByMeNcrQuery,
} from "store/slices/apis/keyNcrSlice";
import dayjs from "dayjs";
import { usePermission } from "hooks/usePermission";
import { QUALITY_VIEW, QUALITY_DELETE } from "config";
import { ReactComponent as SearchIcon } from "assets/PwC_Funct_Icons_Search_Outline_Black_RGB.svg"
import { ReactComponent as CrossIcon } from "assets/PwC_Funct_Icons_Close_Outline_Black_RGB.svg"
import { ReactComponent as CalendarIcon } from "assets/PwC_Funct_Icons_Calendar_Outline_Black_RGB.svg"
import { QUALITY_EDIT } from "config";

const columns = [
  {
    name: "Quality ID",
    field: "ncrNumber",
    renderer(params) {
      return (
        <Stack direction="row" spacing={1}>
          {params?.ncrNumber && (
            <Chip
              label={params?.ncrNumber}
              size="small"
              sx={{
                fontSize: "12px",
                "& .MuiChip-label": {
                  paddingLeft: "8px",
                  paddingRight: "8px",
                  fontWeight: 600,
                },
              }}
            />
          )}
        </Stack>
      );
    },
  },
  {
    name: "Consultant/Contractor",
    field: "contactor_Name",
  },
  {
    name: "Workflow status",
    field: "workflowStatus",
  },
  {
    name: "Current status",
    field: "currentStatus",
  },
  {
    name: "Created Date",
    field: "createdDate",
    renderer(params) {
      return (
        <>
          {params?.createdDate
            ? moment(params.createdDate).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Category",
    field: "package",
  },
  {
    name: "Date Of Issue Of NCR",
    field: "dateOfIssueOfNCR",
    renderer(params) {
      return (
        <>
          {params?.dateOfIssueOfNCR
            ? moment(params.dateOfIssueOfNCR).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Planned Date Of Corrective Action Compeltion",
    field: "plannedDateOfCorrectiveActionCompeltion",
    renderer(params) {
      return (
        <>
          {params?.plannedDateOfCorrectiveActionCompeltion
            ? moment(params.plannedDateOfCorrectiveActionCompeltion).format(
              "DD/MM/YY"
            )
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Actual Expected Date Of Corrective Action Compeltion",
    field: "actualExpectedDateOfCorrectiveActionCompeltion",
    renderer(params) {
      return (
        <>
          {params?.actualExpectedDateOfCorrectiveActionCompeltion
            ? moment(
              params.actualExpectedDateOfCorrectiveActionCompeltion
            ).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Planned Date Of NCR Close",
    field: "plannedDateOfNCRClose",
    renderer(params) {
      return (
        <>
          {params?.plannedDateOfNCRClose
            ? moment(params.plannedDateOfNCRClose).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "Actual Expected Date Of NCR Close",
    field: "actualExpectedDateOfNCRClose",
    renderer(params) {
      return (
        <>
          {params?.actualExpectedDateOfNCRClose
            ? moment(params.actualExpectedDateOfNCRClose).format("DD/MM/YY")
            : "N.A."}
        </>
      );
    },
  },
  {
    name: "NCR Raised By",
    field: "ncrRaisedBy",
  },
  {
    name: "Action",
    field: "action",
    option: {},
  },
];

const approvedStatuses = [
  { label: "Open", value: "Open" },
  { label: "Close", value: "Close" },
  // { label: "Rejected", value: "Rejected" },
];

const NcrSubmittedByMe = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const viewAccess = usePermission(QUALITY_VIEW);
  const editAccess = usePermission(QUALITY_EDIT);
  const deleteAccess = usePermission(QUALITY_DELETE);

  const [showAddIssue, setShowAddIssue] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [deleteItem, setDeleteItem] = useState(null);
  const [isDeleteModal, setDeleteModal] = useState(false);

  // filter data
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [approvedStatus, setApprovedStatus] = useState("");

  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    approvedStatus: "",
  });

  // Edit model state
  const [isEditIssueModal, setEditIssueModal] = useState(false);
  const [issueData, setEditIssueData] = useState(null);

  // View model state
  const [isViewIssueModal, setIsViewIssueModal] = useState(false);

  const { projectId } = useParams();
  const {
    data: getSubmittedByMeNcr,
    isLoading,
    refetch,
  } = useGetSubmittedByMeNcrQuery({
    projectId,
    page: pageNumber,
    fromDate: filters?.fromDate,
    toDate: filters?.toDate,
    currentStatus: filters?.approvedStatus,
  });
  const [ncrDeleteFn, ncrDeleteRes] = useDeleteKeyNcrMutation();

  const dispatch = useDispatch();

  const handleAddIssue = () => {
    setShowAddIssue(!showAddIssue);
  };

  const CustomCalendarIcon = (props) => (
    <CalendarIcon {...props} style={{ width: 26, height: 26, fill: "#696969 ", stroke: "#696969", strokeWidth: 4 }} />
  );

  const openNotification = async (msg, type = "error") => {
    await dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: {
          color: type,
        },
        close: false,
      })
    );

    setTimeout(() => dispatch(closeSnackbar()), 3000);
  };

  const handleActionEdit = (row) => {
    setEditIssueModal(!isEditIssueModal);
    if (!issueData) {
      setEditIssueData(row);
    } else {
      setEditIssueData(null);
    }
  };

  const encrypt = (text) => btoa(unescape(encodeURIComponent(text)));

  const handleActionView = (row) => {
    const encrypted = encrypt("view");
    navigate(`/projects/${projectId}/ncr-detail/${row?.id}/${encrypted}/false`);
    // setIsViewIssueModal(!isViewIssueModal);
    // if (!issueData) {
    //   setEditIssueData(row);
    // } else {
    //   setEditIssueData(null);
    // }
  };
  const handleActionDelete = (row) => {
    setDeleteItem(row);
    setDeleteModal(true);
  };

  const handleConfirmationDelete = () => {
    ncrDeleteFn(deleteItem?.id);
  };

  useEffect(() => {
    if (ncrDeleteRes?.isSuccess) {
      if (ncrDeleteRes?.data?.status == "Success") {
        openNotification(ncrDeleteRes?.data?.message, "success");
        refetch();
      } else {
        openNotification(ncrDeleteRes?.data?.message, "error");
      }
      handleCloseDelete();
    }
  }, [ncrDeleteRes?.isSuccess]);

  const handleCloseDelete = () => {
    setDeleteItem(null);
    setDeleteModal(false);
  };

  const confirmationDeleteDialog = () => (
    <Dialog open={isDeleteModal} aria-labelledby="draggable-dialog-title">
      <DialogTitle
        sx={{
          fontWeight: 500,
          fontSize: "20px",
          color: "#252525",
          paddingBottom: 0,
        }}
        id="draggable-dialog-title"
      >
        Delete
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleCloseDelete}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        {/* <IoMdClose style={{ fontSize: "20px" }} /> */}
        <CrossIcon style={{ fontSize: "20px", width: "20px", height: "20px" }} />
      </IconButton>
      <DialogContent>
        <DialogContentText
          sx={{ fontWeight: 400, fontSize: "16px", color: "#474747" }}
        >
          Are you sure you want to Delete this quality? This action is
          permanent.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        {/* <Button variant="outlined" onClick={handleCloseDelete} sx={{
                    color: '#415385',
                    fontSize: '16px',
                    fontWeight: '500',
                    textTransform: 'none',
                    border: '1px solid #415385'
                }}>Cancel</Button> */}
        <Button
          onClick={handleConfirmationDelete}
          loading={ncrDeleteRes?.isLoading}
          variant="contained"
          sx={{
            backgroundColor: "#C52A1A",
            color: "#fff",
            fontSize: "16px",
            fontWeight: "500",
            textTransform: "none",
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );

  return (
    <>
      {confirmationDeleteDialog()}
      <Grid2 container spacing={2} sx={{ mt: "20px" }}>
        <Grid2 size={12}>
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            gap: 2,
            flexWrap: 'wrap',
          }}>

            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              sx={{
                flexGrow: 1,
                flexWrap: 'wrap',
                alignItems: { xs: 'stretch', sm: 'center' },
                gap: { xs: 1, sm: 2 },
                width: { xs: '100%', sm: 'auto' },
                "& .MuiStack-root": {
                  paddingTop: "15px",
                },
              }}>
              <LocalizationProvider dateAdapter={AdapterDayjs} size="small">
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="From Date"
                    value={fromDate}
                    format="DD-MM-YYYY"
                    onChange={(newValue) => setFromDate(newValue)}
                    slots={{
                      openPickerIcon: CustomCalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: "",
                            toDate: toDate
                              ? dayjs(toDate).format("YYYY-MM-DD")
                              : "",
                            approvedStatus,
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker", "DatePicker"]}>
                  <DatePicker
                    label="To Date"
                    value={toDate}
                    format="DD-MM-YYYY"
                    clearable={true}
                    onChange={(newValue) => setToDate(newValue)}
                    slots={{
                      openPickerIcon: CustomCalendarIcon,
                    }}
                    slotProps={{
                      textField: {
                        sx: {
                          minWidth: 150,
                          "& .MuiOutlinedInput-input": {
                            padding: "10px",
                          },

                          "& .MuiInputLabel-root": {
                            top: "-6px",
                          },
                        },
                      },
                      field: {
                        clearable: true,
                        onClear: () =>
                          setFilters({
                            fromDate: fromDate
                              ? dayjs(fromDate).format("YYYY-MM-DD")
                              : "",
                            toDate: "",
                            approvedStatus,
                          }),
                      },
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
              <Autocomplete
                options={approvedStatuses}
                getOptionLabel={(option) => option?.label || ""}
                value={
                  approvedStatuses.find((opt) => opt.value === approvedStatus) || null
                }
                onChange={(_, newValue) =>
                  setApprovedStatus(newValue ? newValue?.value : "")
                }
                sx={{
                  "& .MuiAutocomplete-inputRoot": {
                    paddingTop: "8px !important",
                    paddingBottom: "7px !important",
                    paddingRight: "0px !important",
                  },
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Current Status"
                    name="approvedStatus"
                    // slotProps={{ inputLabel: { shrink: true } }}
                    variant="outlined"
                    size="small"
                    sx={{
                      "& .MuiFilledInput-root": {
                        backgroundColor: "#fff",
                      },

                      // "& .MuiInputLabel-root": {
                      //   top: "-6px",
                      // },
                      minWidth: "230px",
                      marginTop: "12px",
                    }}
                  />
                )}
                ListboxProps={{
                  sx: { fontSize: "13px" },
                }}
              // sx={{ width: "23%", marginTop: "7px !important" }}
              />
              <Button
                loading={isLoading}
                onClick={() => {
                  setFilters({
                    fromDate: fromDate
                      ? dayjs(fromDate).format("YYYY-MM-DD")
                      : "",
                    toDate: toDate ? dayjs(toDate).format("YYYY-MM-DD") : "",
                    approvedStatus,
                  });
                }}
                size="large"
                // startIcon={<IoMdSearch />}
                startIcon={<SearchIcon style={{ height: "20px", width: "20px", fill: `${theme?.customSettings?.themeColor}` }} />}
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 20px",
                  marginTop: "12px !important",
                }}
              >
                Search
              </Button>
              <Button
                loading={isLoading}
                onClick={() => {
                  setFromDate(null);
                  setToDate(null);
                  setApprovedStatus(null)
                  const clearedValues = Object.fromEntries(
                    Object.keys(filters).map((key) => [key, ""])
                  );
                  setFilters(clearedValues);
                }}
                size="large"
                variant="outlined"
                sx={{
                  color: `${theme?.customSettings?.themeColor}`,
                  border: `1px solid ${theme?.customSettings?.themeColor}`,
                  background: "none",
                  textTransform: "inherit",
                  padding: "6px 15px",
                  marginTop: "12px !important",
                }}
              >
                Reset
              </Button>
            </Stack>
          </Box>
        </Grid2>
        <Grid2 size={12} sx={{ mt: 2 }}>
          <TableComponent
            columns={columns
              .map((col) =>
                col.field === "action"
                  ? {
                    ...col,
                    option: {
                      ...col.option,
                      view: viewAccess,
                      // edit:editAccess,
                      delete: deleteAccess
                    },
                  }
                  : col
              )
              .filter((col) => {
                if (col.field !== "action") {
                  return true;
                } else {
                  return Object.values(col.option).some((v) => v === true);
                }

              })}
            data={getSubmittedByMeNcr?.data?.ncr?.filter(
              (ncr) => ncr?.isDeleted === false
            )}
            actionDelete={handleActionDelete}
            actionEdit={handleActionEdit}
            actionView={handleActionView}
            isLoading={isLoading}
          />
          {!isLoading && (
            <Box sx={{ display: "flex", justifyContent: "end" }}>
              <PaginationComponent
                pageNumber={getSubmittedByMeNcr?.data?.page || 1}
                totalPages={
                  Math.ceil(
                    getSubmittedByMeNcr?.data?.totalRecords /
                    getSubmittedByMeNcr?.data?.pageSize
                  ) || 1
                }
                onPageChange={setPageNumber}
              />
            </Box>
          )}
        </Grid2>
      </Grid2>

      {showAddIssue && (
        <AddNcr
          cancelIssue={handleAddIssue}
          open={showAddIssue}
          openNotification={openNotification}
          refetch={refetch}
        />
      )}
      {/* Here Dialog box for edit  issue */}
      {isEditIssueModal && (
        <EditNcr
          cancelIssue={handleActionEdit}
          open={isEditIssueModal}
          data={issueData}
          openNotification={openNotification}
          refetch={refetch}
        />
      )}

      {isViewIssueModal && (
        <EditNcr
          cancelIssue={handleActionView}
          open={isViewIssueModal}
          data={issueData}
          openNotification={openNotification}
          isViewIssueModal
          refetch={refetch}
        />
      )}
    </>
  );
};

export default NcrSubmittedByMe;
